import { IDuplicateNFTsState } from 'models'
import { orderRef, order, chainTypes } from 'constant'

/* ------------- Initial State ------------- */

export const DUPLICATE_NFTS_INITIAL_STATE: IDuplicateNFTsState = {
  collections: [],
  loading: false,
  isRequesting: false,
  hasInitialized: false,
  hasDataToLoad: true,
  activeChain: chainTypes.ETHEREUM,
  orderRef: orderRef.MARKET_CAP,
  order: order.DESC,
}